import LessonEntry from "./LessonEntry.tsx";
export const DATA = {
  data: [
    {
      Classroom: "\u0430\u0443\u0434.",
      DateIn: "2025-02-10",
      DateOut: "2025-06-07",
      Day: "\u041f\u043e\u043d\u0435\u0434\u0435\u043b\u044c\u043d\u0438\u043a",
      DayNumber: 1,
      Discipline:
        "\u041f\u0440\u043e\u0435\u043a\u0442\u043d\u0430\u044f \u0434\u0435\u044f\u0442\u0435\u043b\u044c\u043d\u043e\u0441\u0442\u044c",
      Discipline_Type: "\u041f\u0440\u0430\u043a\u0442",
      FIO_teacher:
        "\u0434\u043e\u0446. \u0411\u043b\u0430\u0433\u0443\u0448 \u0418.\u0421.",
      Faculty: "202",
      Group: "101/1",
      IdGroup: "224003618",
      IdSchedule: 79868,
      Lesson: 4,
      TimeIn: "13:00:00.0000000",
      TimeOut: "14:20:00.0000000",
    },
    {
      Classroom: "\u0430\u0443\u0434",
      DateIn: "2025-02-10",
      DateOut: "2025-06-07",
      Day: "\u041f\u043e\u043d\u0435\u0434\u0435\u043b\u044c\u043d\u0438\u043a",
      DayNumber: 1,
      Discipline:
        "\u041f\u0441\u0438\u0445\u043e\u043b\u043e\u0433\u0438\u044f",
      Discipline_Type: "\u041b\u0435\u043a",
      FIO_teacher:
        "\u0434\u043e\u0446. \u0418\u0432\u0430\u043d\u043e\u0432 \u041e.\u0412.",
      Faculty: "202",
      Group: "101/1",
      IdGroup: "224003618",
      IdSchedule: 79828,
      Lesson: 5,
      TimeIn: "14:30:00.0000000",
      TimeOut: "15:50:00.0000000",
    },
    {
      Classroom: "\u0430\u0443\u0434.",
      DateIn: "2025-02-10",
      DateOut: "2025-06-07",
      Day: "\u041f\u043e\u043d\u0435\u0434\u0435\u043b\u044c\u043d\u0438\u043a",
      DayNumber: 1,
      Discipline:
        "\u041f\u0440\u0430\u043a\u0442. \u0433\u0440\u0430\u043c\u043c. (1)",
      Discipline_Type: "\u041f\u0440\u0430\u043a\u0442",
      FIO_teacher:
        "\u0434\u043e\u0446. \u0421\u043e\u043b\u043e\u0432\u0435\u0439 \u0410.\u0410.",
      Faculty: "202",
      Group: "101/1",
      IdGroup: "224003618",
      IdSchedule: 79869,
      Lesson: 6,
      TimeIn: "16:00:00.0000000",
      TimeOut: "17:20:00.0000000",
    },
    {
      Classroom: "\u0430\u0443\u0434.",
      DateIn: "2025-02-10",
      DateOut: "2025-06-07",
      Day: "\u041f\u043e\u043d\u0435\u0434\u0435\u043b\u044c\u043d\u0438\u043a",
      DayNumber: 1,
      Discipline: "\u041f\u0440\u0430\u043a\u0442. \u0444\u043e\u043d. (2)",
      Discipline_Type: "\u041f\u0440\u0430\u043a\u0442",
      FIO_teacher:
        "\u043f\u0440. \u0423\u0441\u0442\u0438\u043d\u043e\u0432\u0438\u0447 \u0412.\u0412.",
      Faculty: "202",
      Group: "101/1",
      IdGroup: "224003618",
      IdSchedule: 79870,
      Lesson: 7,
      TimeIn: "17:30:00.0000000",
      TimeOut: "18:50:00.0000000",
    },
    {
      Classroom: "\u0430\u0443\u0434.",
      DateIn: "2025-02-10",
      DateOut: "2025-06-07",
      Day: "\u0412\u0442\u043e\u0440\u043d\u0438\u043a",
      DayNumber: 2,
      Discipline: "\u041f\u0440\u0430\u043a\u0442. \u0444\u043e\u043d. (1)",
      Discipline_Type: "\u041f\u0440\u0430\u043a\u0442",
      FIO_teacher:
        "\u043f\u0440. \u0414\u0443\u0440\u0430\u043d\u043a\u043e\u0432\u0430 \u0410.\u0410.",
      Faculty: "202",
      Group: "101/1",
      IdGroup: "224003618",
      IdSchedule: 79871,
      Lesson: 5,
      TimeIn: "14:30:00.0000000",
      TimeOut: "15:50:00.0000000",
    },
    {
      Classroom: "\u0430\u0443\u0434.",
      DateIn: "2025-02-10",
      DateOut: "2025-06-07",
      Day: "\u0412\u0442\u043e\u0440\u043d\u0438\u043a",
      DayNumber: 2,
      Discipline: "\u041f\u0423\u041f\u0420 (1)",
      Discipline_Type: "\u041f\u0440\u0430\u043a\u0442",
      FIO_teacher:
        "\u0434\u043e\u0446. \u0414\u0443\u0431\u0440\u043e\u0432\u0447\u0435\u043d\u043a\u043e \u0415.\u041c.",
      Faculty: "202",
      Group: "101/1",
      IdGroup: "224003618",
      IdSchedule: 79872,
      Lesson: 6,
      TimeIn: "16:00:00.0000000",
      TimeOut: "17:20:00.0000000",
    },
    {
      Classroom: "\u0430\u0443\u0434",
      DateIn: "2025-02-10",
      DateOut: "2025-06-07",
      Day: "\u0412\u0442\u043e\u0440\u043d\u0438\u043a",
      DayNumber: 2,
      Discipline:
        "\u041f\u0441\u0438\u0445\u043e\u043b\u043e\u0433\u0438\u044f",
      Discipline_Type: "\u041b\u0435\u043a",
      FIO_teacher:
        "\u0434\u043e\u0446. \u0418\u0432\u0430\u043d\u043e\u0432 \u041e.\u0412.",
      Faculty: "202",
      Group: "101/1",
      IdGroup: "224003618",
      IdSchedule: 79836,
      Lesson: 7,
      TimeIn: "17:30:00.0000000",
      TimeOut: "18:50:00.0000000",
    },
    {
      Classroom: "\u0430\u0443\u0434.",
      DateIn: "2025-02-10",
      DateOut: "2025-06-07",
      Day: "\u0421\u0440\u0435\u0434\u0430",
      DayNumber: 3,
      Discipline:
        "\u0418\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0438\u043e\u043d\u043d\u044b\u0439 \u0447\u0430\u0441",
      Discipline_Type: "\u0421\u0435\u043c",
      FIO_teacher:
        "\u043f\u0440. \u0414\u0443\u0440\u0430\u043d\u043a\u043e\u0432\u0430 \u0410.\u0410.",
      Faculty: "202",
      Group: "101/1",
      IdGroup: "224003618",
      IdSchedule: 79873,
      Lesson: 4,
      TimeIn: "13:00:00.0000000",
      TimeOut: "14:20:00.0000000",
    },
    {
      Classroom: "\u0430\u0443\u0434.",
      DateIn: "2025-02-10",
      DateOut: "2025-06-07",
      Day: "\u0421\u0440\u0435\u0434\u0430",
      DayNumber: 3,
      Discipline:
        "\u041f\u0440\u0430\u043a\u0442. \u0433\u0440\u0430\u043c\u043c. (1)",
      Discipline_Type: "\u041f\u0440\u0430\u043a\u0442",
      FIO_teacher:
        "\u0434\u043e\u0446. \u0421\u043e\u043b\u043e\u0432\u0435\u0439 \u0410.\u0410.",
      Faculty: "202",
      Group: "101/1",
      IdGroup: "224003618",
      IdSchedule: 79875,
      Lesson: 5,
      TimeIn: "14:30:00.0000000",
      TimeOut: "15:50:00.0000000",
    },
    {
      Classroom: "\u0430\u0443\u0434.",
      DateIn: "2025-02-10",
      DateOut: "2025-06-07",
      Day: "\u0421\u0440\u0435\u0434\u0430",
      DayNumber: 3,
      Discipline:
        "\u041f\u0440\u0430\u043a\u0442. \u0433\u0440\u0430\u043c\u043c. (2)",
      Discipline_Type: "\u041f\u0440\u0430\u043a\u0442",
      FIO_teacher:
        "\u043f\u0440. \u0423\u0441\u0442\u0438\u043d\u043e\u0432\u0438\u0447 \u0412.\u0412.",
      Faculty: "202",
      Group: "101/1",
      IdGroup: "224003618",
      IdSchedule: 79876,
      Lesson: 6,
      TimeIn: "16:00:00.0000000",
      TimeOut: "17:20:00.0000000",
    },
    {
      Classroom: "\u0430\u0443\u0434.",
      DateIn: "2025-02-10",
      DateOut: "2025-06-07",
      Day: "\u0421\u0440\u0435\u0434\u0430",
      DayNumber: 3,
      Discipline:
        ".\u0410\u0443\u0434\u0438\u0440\u043e\u0432\u0430\u043d\u0438\u0435 \u0438\u043d\u043e\u044f\u0437\u044b\u0447\u043d\u043e\u0439 \u0440\u0435\u0447\u0438",
      Discipline_Type: "\u041f\u0440\u0430\u043a\u0442",
      FIO_teacher:
        "\u0441\u0442.\u043f\u0440. \u0411\u0435\u043d\u0435\u0434\u0438\u043a\u0442\u043e\u0432\u0438\u0447 \u0410.\u0412.",
      Faculty: "202",
      Group: "101/1",
      IdGroup: "224003618",
      IdSchedule: 79877,
      Lesson: 7,
      TimeIn: "17:30:00.0000000",
      TimeOut: "18:50:00.0000000",
    },
    {
      Classroom: "\u0430\u0443\u0434.",
      DateIn: "2025-02-10",
      DateOut: "2025-06-07",
      Day: "\u0427\u0435\u0442\u0432\u0435\u0440\u0433",
      DayNumber: 4,
      Discipline: "\u041f\u0440\u0430\u043a\u0442. \u0444\u043e\u043d. (1)",
      Discipline_Type: "\u041f\u0440\u0430\u043a\u0442",
      FIO_teacher:
        "\u043f\u0440. \u0414\u0443\u0440\u0430\u043d\u043a\u043e\u0432\u0430 \u0410.\u0410.",
      Faculty: "202",
      Group: "101/1",
      IdGroup: "224003618",
      IdSchedule: 79878,
      Lesson: 4,
      TimeIn: "13:00:00.0000000",
      TimeOut: "14:20:00.0000000",
    },
    {
      Classroom: "\u0430\u0443\u0434.",
      DateIn: "2025-02-10",
      DateOut: "2025-06-07",
      Day: "\u0427\u0435\u0442\u0432\u0435\u0440\u0433",
      DayNumber: 4,
      Discipline:
        "\u041f\u0440\u0430\u043a\u0442. \u0433\u0440\u0430\u043c\u043c. (1)",
      Discipline_Type: "\u041f\u0440\u0430\u043a\u0442",
      FIO_teacher:
        "\u0434\u043e\u0446. \u0421\u043e\u043b\u043e\u0432\u0435\u0439 \u0410.\u0410.",
      Faculty: "202",
      Group: "101/1",
      IdGroup: "224003618",
      IdSchedule: 79879,
      Lesson: 5,
      TimeIn: "14:30:00.0000000",
      TimeOut: "15:50:00.0000000",
    },
    {
      Classroom: "\u0430\u0443\u0434",
      DateIn: "2025-02-10",
      DateOut: "2025-06-07",
      Day: "\u0427\u0435\u0442\u0432\u0435\u0440\u0433",
      DayNumber: 4,
      Discipline:
        "\u041f\u0435\u0434\u0430\u0433\u043e\u0433\u0438\u043a\u0430",
      Discipline_Type: "\u041b\u0435\u043a",
      FIO_teacher:
        "\u0434\u043e\u0446. \u041f\u0430\u0448\u043a\u0435\u0432\u0438\u0447 \u0412.\u0412.",
      Faculty: "202",
      Group: "101/1",
      IdGroup: "224003618",
      IdSchedule: 79844,
      Lesson: 6,
      TimeIn: "16:00:00.0000000",
      TimeOut: "17:20:00.0000000",
    },
    {
      Classroom: "\u0430\u0443\u0434.",
      DateIn: "2025-02-10",
      DateOut: "2025-06-07",
      Day: "\u0427\u0435\u0442\u0432\u0435\u0440\u0433",
      DayNumber: 4,
      Discipline: "\u041f\u0423\u041f\u0420 (1)",
      Discipline_Type: "\u041f\u0440\u0430\u043a\u0442",
      FIO_teacher:
        "\u0434\u043e\u0446. \u0414\u0443\u0431\u0440\u043e\u0432\u0447\u0435\u043d\u043a\u043e \u0415.\u041c.",
      Faculty: "202",
      Group: "101/1",
      IdGroup: "224003618",
      IdSchedule: 79880,
      Lesson: 7,
      TimeIn: "17:30:00.0000000",
      TimeOut: "18:50:00.0000000",
    },
    {
      Classroom: "\u0430\u0443\u0434.",
      DateIn: "2025-02-10",
      DateOut: "2025-06-07",
      Day: "\u0421\u0443\u0431\u0431\u043e\u0442\u0430",
      DayNumber: 6,
      Discipline: "\u041f\u0423\u041f\u0420 (1)",
      Discipline_Type: "\u041f\u0440\u0430\u043a\u0442",
      FIO_teacher:
        "\u0434\u043e\u0446. \u0414\u0443\u0431\u0440\u043e\u0432\u0447\u0435\u043d\u043a\u043e \u0415.\u041c.",
      Faculty: "202",
      Group: "101/1",
      IdGroup: "224003618",
      IdSchedule: 79881,
      Lesson: 5,
      TimeIn: "14:30:00.0000000",
      TimeOut: "15:50:00.0000000",
    },
    {
      Classroom: "\u0430\u0443\u0434",
      DateIn: "2025-02-10",
      DateOut: "2025-06-07",
      Day: "\u0421\u0443\u0431\u0431\u043e\u0442\u0430",
      DayNumber: 6,
      Discipline:
        "\u0412\u0432\u0435\u0434. \u0432 \u044f\u0437\u044b\u043a\u043e\u0437\u043d\u0430\u043d\u0438\u0435",
      Discipline_Type: "\u041b\u0435\u043a",
      FIO_teacher:
        "\u0434\u043e\u0446. \u041b\u0435\u043e\u043d\u0442\u044c\u0435\u0432\u0430 \u0412.\u0412.",
      Faculty: "202",
      Group: "101/1",
      IdGroup: "224003618",
      IdSchedule: 79852,
      Lesson: 6,
      TimeIn: "16:00:00.0000000",
      TimeOut: "17:20:00.0000000",
    },
    {
      Classroom: "\u0430\u0443\u0434.",
      DateIn: "2025-02-10",
      DateOut: "2025-06-07",
      Day: "\u0421\u0443\u0431\u0431\u043e\u0442\u0430",
      DayNumber: 6,
      Discipline: "\u041f\u0423\u041f\u0420 (2)",
      Discipline_Type: "\u041f\u0440\u0430\u043a\u0442",
      FIO_teacher:
        "\u043f\u0440. \u0423\u0441\u0442\u0438\u043d\u043e\u0432\u0438\u0447 \u0412.\u0412.",
      Faculty: "202",
      Group: "101/1",
      IdGroup: "224003618",
      IdSchedule: 79882,
      Lesson: 7,
      TimeIn: "17:30:00.0000000",
      TimeOut: "18:50:00.0000000",
    },
  ],
};

interface IScheduleEntry {
  Classroom: string;
  DateIn: string;
  DateOut: string;
  Day: string;
  DayNumber: number;
  Discipline: string;
  Discipline_Type: string;
  FIO_teacher: string;
  Faculty: string;
  Group: string;
  IdGroup: string;
  IdSchedule: number;
  Lesson: number;
  TimeIn: string;
  TimeOut: string;
}

const Render = (data: IScheduleEntry[]) => {
  let List = data.map((item, _) => {
    return (
      <LessonEntry
        Classroom={item.Classroom}
        Discipline={item.Discipline}
        Discipline_Type={item.Discipline_Type}
        Day={item.Day}
        FIO_teacher={item.FIO_teacher}
        TimeIn={item.TimeIn}
        TimeOut={item.TimeOut}
      />
    );
  });
  return List;
};

function SeparateToDays(data: IScheduleEntry[]) {
  let entry: IScheduleEntry;
  let week = {
    Monday: [] as IScheduleEntry[],
    Tuesday: [] as IScheduleEntry[],
    Wednesday: [] as IScheduleEntry[],
    Thursday: [] as IScheduleEntry[],
    Friday: [] as IScheduleEntry[],
    Saturday: [] as IScheduleEntry[],
    Sunday: [] as IScheduleEntry[],
  };
  for (entry of data) {
    switch (entry.DayNumber) {
      case 1:
        week.Monday.push(entry);
        break;
      case 2:
        week.Tuesday.push(entry);
        break;
      case 3:
        week.Wednesday.push(entry);
        break;
      case 4:
        week.Thursday.push(entry);
        break;
      case 5:
        week.Friday.push(entry);
        break;
      case 6:
        week.Saturday.push(entry);
        break;
      case 7:
        week.Sunday.push(entry);
        break;
    }
  }

  for (let [day, val] of Object.entries(week)) {
    val.sort((a, b) => {
      return a.DayNumber - b.DayNumber;
    });
    console.log(`${day}:${val}`);
  }
  return week;
}

export default function ScheduleEntry() {
  const w = SeparateToDays(DATA.data);
  console.log(w);
  return (
    <div className="flex flex-col flex-wrap justify-between ">
      <div>
        <h1 className="ml-2 font-Roboto font-black text-3xl">Понедельник</h1>
        <div className="flex flex-col justify-between gap-1">
          {Render(w.Monday)}
        </div>
      </div>
      <div>
        <h1 className="ml-2 font-Roboto font-black text-3xl">Вторник</h1>
        <div className="flex flex-col justify-between gap-1">
          {Render(w.Tuesday)}
        </div>
      </div>
      <div>
        <h1 className="ml-2 font-Roboto font-black text-3xl">Среда</h1>
        <div className="flex flex-col justify-between gap-1">
          {Render(w.Wednesday)}
        </div>
      </div>
      <div>
        <h1 className="ml-2 font-Roboto font-black text-3xl">Четверг</h1>
        <div className="flex flex-col justify-between gap-1">
          {Render(w.Thursday)}
        </div>
      </div>
      <div>
        <h1 className="ml-2 font-Roboto font-black text-3xl">Пятница</h1>
        <div className="flex flex-col justify-between gap-1">
          {Render(w.Friday)}
        </div>
      </div>
      <div>
        <h1 className="ml-2 font-Roboto font-black text-3xl">Суббота</h1>
        <div className="flex flex-col justify-between gap-1">
          {Render(w.Saturday)}
        </div>
      </div>
      <div>
        <h1 className="ml-2 font-Roboto font-black text-3xl">Восскресенье</h1>
        <div className="flex flex-col justify-between gap-1">
          {Render(w.Sunday)}
        </div>
      </div>
    </div>
  );
}
